import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

export default new Router({
    mode: "history",
    routes: [
        {
            path: '/',
            redirect: "/home/index"
        },
        {
            path: '/browserError',
            name: "browserError",
            meta: {requireAuth: false, title: "错误", permission_id: ""},
            component(resolve) {
                require([`@/page/error/browserError`], resolve)
            }
        },
        // 授权
        {
            path: "/home",
            name: "home",
            redirect: "/home/index",
            component: () =>
                import(`@/page/homePage`),
            children: [{
                path: 'index',
                name: 'homeindex',
                component: () =>
                    import(`@/page/homePage/homeIndex`),
                meta: {title: "首页"},
            },
                {
                    path: 'mall',
                    name: 'homemall',
                    component: () =>
                        import(`@/page/homePage/homeMall`),
                    meta: {title: "商城"},
                },
                {
                    path: 'info',
                    name: 'homeminfo',
                    component: () =>
                        import(`@/page/homePage/homeInfo`),
                    meta: {requireAuth: true, title: "知识库"},
                },
                // 知识库详情
                {
                    path: 'infodetail',
                    name: 'infodetail',
                    component: () =>
                        import(`@/page/homePage/homeInfo/detail`),
                    meta: {requireAuth: true, title: "知识库详情"},
                },
                {
                    path: 'contact',
                    name: 'homemcontact',
                    component: () =>
                        import(`@/page/homePage/homeContact`),
                    meta: {title: "联系我们"},
                },
                // 商品详情
                {
                    path: 'detail',
                    name: 'goodsdetail',
                    component: () =>
                        import(`@/page/homePage/goodsDetails`),
                    meta: {requireAuth: true, title: "商品详情"},
                },
                // 购物车
                {
                    path: 'shopcart',
                    name: 'shopCart',
                    component: () =>
                        import(`@/page/homePage/shopCart`),
                    meta: {requireAuth: true, title: "购物车"},
                },
                // 确认订单
                {
                    path: 'confirm',
                    name: 'confirm',
                    component: () =>
                        import(`@/page/homePage/confirmOrder`),
                    meta: {requireAuth: true, title: "确认订单"},
                },
            ]
        },

        //    登录
        {
            path: '/login',
            component: () =>
                import(`@/page/login/index.vue`)
        },
        //    微信授权登录
        {
            path: '/auth',
            component: () => import(`@/page/login/auth`)
        },
        //  绑定手机号码
        {
            path: '/bindPhone',
            component: () =>
                import(`@/page/login/bind-phone.vue`)
        },
        //协议页面
        {
            path: '/protocol',
            component: () =>
                import(`@/page/register/Protocol.vue`)

        },
        //协议页面
        {
            path: '/export',
            component: () =>
                import(`@/page/me/myContract/outcontract`),
            meta: {
                keepalive: true
            }
        },
        //    注册   成为vip客户  入驻供应商
        {
            path: '/register',
            component: () =>
                import('@/page/register/index'),
            children: [
                //入驻供应商
                {
                    path: "applyMerchants",
                    component: () =>
                        import('@/page/register/ApplyMerchants'),
                    meta: {
                        requireAuth: true
                    }
                },
                //    入驻企业
                {
                    path: "applyCompany",
                    component: () =>
                        import('@/page/register/ApplyCompany'),
                    meta: {
                        requireAuth: true
                    }
                },
                //    重新入供应商
                {
                    path: "reapplyMerchants",
                    component: () =>
                        import('@/page/register/ReapplyMerchants'),
                    meta: {
                        requireAuth: true
                    }
                },
                //    重新入企业
                {
                    path: "reapplyCompany",
                    component: () =>
                        import('@/page/register/ReapplyCompany'),
                    meta: {
                        requireAuth: true
                    }
                }
            ]
        },
        // 订单详情
        {
            path: "/orderdetail",
            component: () =>
                import('@/page/me/myorder/orderdetail'),
            meta: {
                requireAuth: true
            }
        },
        // 订单详情-反馈
        {
            path: "/feedback",
            component: () =>
                import('@/page/me/myorder/Feedback'),
            meta: {
                requireAuth: true
            }
        },
        // 订单详情-反馈详情
        {
            path: "/feedbackdetail",
            component: () =>
                import('@/page/me/myorder/Feedbackdetail'),
            meta: {
                requireAuth: true
            }
        },
        // 订单-评价
        {
            path: "/orderevaluation",
            component: () =>
                import('@/page/me/myorder/evaluation'),
            meta: {
                requireAuth: true
            }
        },

        //  我的客户订单
        // 我的客户订单 订单详情
        {
            path: "/myCustomer/orderdetail",
            component: () =>
                import('@/page/me/myCustomerOrder/orderdetail'),
            meta: {
                requireAuth: true
            }
        },
        // 我的客户订单 订单详情-反馈
        {
            path: "/myCustomer/feedback",
            component: () =>
                import('@/page/me/myCustomerOrder/Feedback'),
            meta: {
                requireAuth: true
            }
        },
        // 我的客户订单 订单详情-反馈详情
        {
            path: "/myCustomer/feedbackdetail",
            component: () =>
                import('@/page/me/myCustomerOrder/Feedbackdetail'),
            meta: {
                requireAuth: true
            }
        },
        // 我的客户订单 订单-评价
        {
            path: "/myCustomer/orderevaluation",
            component: () =>
                import('@/page/me/myCustomerOrder/evaluation'),
            meta: {
                requireAuth: true
            }
        },


        // 服务订单详情
        {
            path: "/servicedetail",
            component: () =>
                import('@/page/me/serviceOrder/servicedetail'),
            meta: {
                requireAuth: true
            }
        },
        // 售后订单-收款
        {
            path: "/reunddetail",
            component: () =>
                import('@/page/me/finance/reunddetail'),
            meta: {
                requireAuth: true
            }
        },
        // 销售-服务订单详情
        {
            path: "/salesservicedetail",
            component: () =>
                import('@/page/me/salesservice/servicedetail'),
            meta: {
                requireAuth: true
            }
        },
        // 技术服务订单详情
        {
            path: "/techniciandetail",
            component: () =>
                import('@/page/me/technician/servicedetail'),
            meta: {
                requireAuth: true
            }
        },
        // 我的合同详情
        {
            name: "contractdetail",
            path: "/contractdetail",
            component: () =>
                import('@/page/me/myContract/contractdetail'),
            meta: {
                requireAuth: true
            }
        },
        // 发起服务订单
        {
            path: "/releaseservice",
            component: () =>
                import('@/page/me/serviceOrder/releaseservice'),
            meta: {
                requireAuth: true
            }
        },
        // 服务订单-评价
        {
            path: "/serviceassents",
            component: () =>
                import('@/page/me/serviceOrder/serviceassents'),
            meta: {
                requireAuth: true
            }
        },
        // 物流列表
        {
            path: "/logistics",
            component: () =>
                import('@/page/me/myorder/logistics'),
            meta: {
                requireAuth: true
            }
        },
        // 销售订单管理 确认订单
        {
            path: '/salesOrder/confirm',
            component: () =>
                import('@/page/me/salesOrder/confirm.vue')
        },
        // 销售订单管理 订单详情
        {
            path: '/salesOrder/detail',
            component: () =>
                import('@/page/me/salesOrder/detail.vue')
        },
        // 支付订单
        {
            path: '/payment',
            component: () =>
                import('@/page/me/payment')
        },
        // 我的收藏
        {
            path: '/collection',
            component: () =>
                import('@/page/me/Collection')
        },
        //    销售 客户资料
        {
            path: '/myCustomer/customerInfo',
            component: () =>
                import('@/page/me/myCustomer/customerInfo')
        },
        //    销售 客户资料
        {
            path: '/myCustomer/updateCustomer',
            component: () =>
                import('@/page/me/myCustomer/updateCustomer')
        },
        //    销售 我的收益 提现
        {
            path: '/myIncome/withdraw',
            component: () =>
                import('@/page/me/myIncome/withdraw')
        },
        //    销售 我的上下级 下级详情
        {
            path: '/myRelation/subDetail',
            component: () =>
                import('@/page/me/myRelation/subDetail')
        },
        //    供应商 供应商物流
        {
            path: '/merchantsOrder/logistice',
            component: () =>
                import('@/page/me/merchantsOrder/logistics')
        },
        // 供应商 合同详情
        {
            path: "/merchantsContract/detail",
            component: () =>
                import('@/page/me/merchantsContract/detail')
        },
        // 供应商 订单详情
        {
            path: "/merchantsOrder/detail",
            component: () =>
                import('@/page/me/merchantsOrder/detail')
        },
        // 供应商订单管理 发货
        {
            path: "/merchantsOrder/send",
            component: () =>
                import('@/page/me/merchantsOrder/send')
        },
        // 供应商 售后反馈
        {
            path: "/merchantsOrder/reply",
            component: () =>
                import('@/page/me/merchantsOrder/reply')
        },
        // 我的文章  详情
        {
            path: "/myInformation/detail",
            component: () =>
                import('@/page/me/myInformation/detail')
        },
        // 我的文章  添加
        {
            path: "/myInformation/add",
            component: () =>
                import('@/page/me/myInformation/add')
        },
        //    个人中心
        {
            path: '/me',
            component: () =>
                import('@/page/me/index/index'),
            meta: {
                requireAuth: true
            },
            children: [

                //个人中心 首页
                {
                    path: "entrance",
                    component: () =>
                        import('@/page/me/entrance/index'),
                    meta: {
                        requireAuth: true
                    }
                },
                //    个人资料
                {
                    path: 'profile',
                    component: () =>
                        import('@/page/me/profile/index')
                },
                //    我的发票
                {
                    path: 'invoice',
                    component: () =>
                        import('@/page/me/invoice')
                },
                //    我的地址
                {
                    path: 'myaddress',
                    component: () =>
                        import('@/page/me/address')
                },
                //    我的地址
                {
                    path: 'message',
                    component: () =>
                        import('@/page/me/message')
                },
                //    我的订单
                {
                    path: 'myorder',
                    component: () =>
                        import('@/page/me/myorder')
                },
                // 我的客户   订单列表
                {
                    path: 'myCustomerOrder',
                    component: () =>
                        import('@/page/me/myCustomerOrder/index')
                },
                //    我的银行卡
                {
                    path: 'mybankcard',
                    component: () =>
                        import('@/page/me/BankCard')
                },
                //    我的银行卡-添加银行卡
                {
                    path: 'addbankcard',
                    component: () =>
                        import('@/page/me/BankCard/add')
                },
                //    我的担保
                {
                    path: 'guarantee',
                    component: () =>
                        import('@/page/me/guarantee')
                },
                //    服务订单
                {
                    path: 'myservice',
                    component: () =>
                        import('@/page/me/serviceOrder')
                },
                //    销售-服务订单
                {
                    path: 'salesservice',
                    component: () =>
                        import('@/page/me/salesservice')
                },
                //    技术-服务订单
                {
                    path: 'technician',
                    component: () =>
                        import('@/page/me/technician')
                },
                //    销售 我的客户
                {
                    path: 'myCustomer',
                    component: () =>
                        import('@/page/me/myCustomer')
                },
                //    财务管理
                {
                    path: 'finance',
                    component: () =>
                        import('@/page/me/finance')
                },
                //    我的合同
                {
                    path: 'mycontract',
                    component: () =>
                        import('@/page/me/myContract')
                },
                //    我的二维码
                {
                    path: 'qrcode',
                    component: () =>
                        import('@/page/me/QRcode')
                },
                //    我的设备
                {
                    name: "mydevice",
                    path: 'mydevice',
                    component: () =>
                        import('@/page/me/myDevice')
                },
                //    我的设备-添加设备
                {
                    path: 'adddevice',
                    component: () =>
                        import('@/page/me/myDevice/addDevice')
                },
                //    我的设备-添加记录
                {
                    path: 'addrecord',
                    component: () =>
                        import('@/page/me/myDevice/addRecord')
                },
                //    我的设备-维护记录
                {
                    path: 'maintain',
                    component: () =>
                        import('@/page/me/myDevice/maintain')
                },
                //    我的设备-维护记录-详情
                {
                    path: 'maintaindetail',
                    component: () =>
                        import('@/page/me/myDevice/maintainDetail')
                },
                //    我的设备-添加评价
                {
                    path: 'deviceevaluation',
                    component: () =>
                        import('@/page/me/myDevice/Evaluation')
                },
                //    我的同事
                {
                    path: "workmate",
                    component: () =>
                        import('@/page/me/workmate/index')
                },
                //    添加同事
                {
                    path: 'workmate/add',
                    component: () =>
                        import('@/page/me/workmate/add.vue')

                },
                // 销售订单管理
                {
                    path: 'salesOrder',
                    component: () =>
                        import('@/page/me/salesOrder/index.vue')
                },

                // 供应商订单管理
                {
                    path: "merchantsOrder",
                    component: () =>
                        import('@/page/me/merchantsOrder/index')
                },

                // 我的文章  列表
                {
                    path: "myInformation",
                    component: () =>
                        import('@/page/me/myInformation/index')
                },

                // 供应商 合同
                {
                    path: "merchantsContract",
                    component: () =>
                        import('@/page/me/merchantsContract/index')
                },
                // 供应商 合同
                {
                    path: "travelReport",
                    component: () =>
                        import('@/page/me/travelReport/index')
                },
                //    我的上下级
                {
                    path: "myRelation",
                    component: () =>
                        import('@/page/me/myRelation/index')
                },
                //    我的收益
                {
                    path: "myIncome",
                    component: () =>
                        import('@/page/me/myIncome/index')
                }
            ]
        }

    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js